export default __webpack_public_path__ + "static/media/hr.9c97186f.svg";